import ContentApi from '../Lib/Api/ContentApi';

export const GET_ALL_CONTENT = 'GET_ALL_CONTENT';
export const GET_ALL_CONTENT_PENDING = 'GET_ALL_CONTENT_PENDING';
export const GET_ALL_CONTENT_REJECTED = 'GET_ALL_CONTENT_REJECTED';
export const GET_ALL_CONTENT_FULFILLED = 'GET_ALL_CONTENT_FULFILLED';

export function getAllContent() {
    const request = ContentApi.getAllContent();

    return {
        type: GET_ALL_CONTENT,
        payload: request
    };
};